import NavigationDrawer from 'views/components/common/NavigationDrawer/NavigationDrawer';

export default NavigationDrawer;
